

// utility functions
export default {
  parseJwt(jwt) {
    var base64Url = jwt.split('.')[1];
    var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(base64);
  },
  isEncoded(uri) {
    uri = uri || '';
  
    return uri !== decodeURIComponent(uri);
  },
  encodeUriComponent(uri) {
    if (this.isEncoded(uri)) {
      return uri;
    }

    return encodeURIComponent(uri);
  },
  decodeUriComponent(uri) {
    if (this.isEncoded(uri)) {
      return decodeURIComponent(uri);
    }

    return uri;
  }
}
